﻿
// JS Dependencies
import 'jquery-validation';
import 'jquery-validation-unobtrusive';

// Custom JS imports
import '../lib/jquery-ui/js/jquery-ui-1.11.1.min.js';
import '../lib/jquery-ui/js/jquery-migrate-1.2.1.min.js';
import '../lib/bootstrap/js/bootstrap.bundle.js';
window.Swal = require('../lib/sweetalert2/sweetalert2.all.min.js');
import '../lib/jquery-tokenize/js/jquery.tokenize.js';
import './mdb.min.js';
import { _shared_xfunc } from '../js/shared/_shared_xfunc.js';

// Custom CSS imports
import '../lib/bootstrap/css/bootstrap.min.css';
import '../css/mdb.min.css';
import '../css/site.css';
import '../css/login.css';
import '../css/fonts.min.css';





import { LoginPage } from './loginpage.js';

console.log('The \'layout3\' bundle has been loaded!');

if (page_name = 'login') {
    new LoginPage()
}
